var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

module.exports =
/*#__PURE__*/
function () {
  "use strict";

  function CentraResponse(res, resOptions) {
    _classCallCheck(this, CentraResponse);

    this.coreRes = res;
    this.resOptions = resOptions;
    this.body = Buffer.alloc(0);
    this.headers = res.headers;
    this.statusCode = res.statusCode;
  }

  _createClass(CentraResponse, [{
    key: "_addChunk",
    value: function _addChunk(chunk) {
      this.body = Buffer.concat([this.body, chunk]);
    }
  }, {
    key: "json",
    value: function () {
      var _json = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", JSON.parse(this.body));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function json() {
        return _json.apply(this, arguments);
      }

      return json;
    }()
  }, {
    key: "text",
    value: function () {
      var _text = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.body.toString());

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function text() {
        return _text.apply(this, arguments);
      }

      return text;
    }()
  }]);

  return CentraResponse;
}();